window.LimiteCredito = Backbone.Model.extend({

});

window.LimitesCredito = Backbone.Collection.extend({
    model: LimiteCredito
});